module.exports = __webpack_public_path__ + "8f53edccb7681e6404e4cc74ec224d35.MP3";